var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62.629,
    height: 41.12,
    viewBox: "0 0 62.629 41.12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#73aabd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.784 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M180.2,85.333a9.595,9.595,0,1,0,9.531,9.595A9.573,9.573,0,0,0,180.2,85.333Zm0,16.448A6.853,6.853,0,1,1,187,94.928,6.84,6.84,0,0,1,180.2,101.781Z",
    transform: "translate(-170.666 -85.333)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.568 10.965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M348.141,170.667a6.853,6.853,0,1,0,6.807,6.853A6.84,6.84,0,0,0,348.141,170.667Zm0,10.965a4.112,4.112,0,1,1,4.084-4.112A4.1,4.1,0,0,1,348.141,181.632Z",
    transform: "translate(-341.334 -170.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.639 10.965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.989,170.667A6.853,6.853,0,1,0,57.8,177.52,6.838,6.838,0,0,0,50.989,170.667Zm0,10.965a4.112,4.112,0,1,1,4.084-4.112A4.1,4.1,0,0,1,50.989,181.632Z",
    transform: "translate(-44.182 -170.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.615 21.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M124.365,256a17.78,17.78,0,0,0-17.7,17.819,1.362,1.362,0,1,0,2.723,0,14.977,14.977,0,1,1,29.953,0,1.362,1.362,0,1,0,2.723,0A17.78,17.78,0,0,0,124.365,256Z",
    transform: "translate(-106.666 -256)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.374 27.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M346.815,298.667a12.193,12.193,0,0,0-6.347,1.782,1.38,1.38,0,0,0-.457,1.883,1.358,1.358,0,0,0,1.871.461,9.447,9.447,0,0,1,4.934-1.384,9.573,9.573,0,0,1,9.53,9.595,1.362,1.362,0,1,0,2.723,0A12.31,12.31,0,0,0,346.815,298.667Z",
    transform: "translate(-339.813 -298.667)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.413)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.6,300.446A12.243,12.243,0,0,0,0,311a1.362,1.362,0,1,0,2.723,0,9.573,9.573,0,0,1,9.53-9.595,9.454,9.454,0,0,1,4.931,1.382,1.359,1.359,0,0,0,1.871-.461A1.375,1.375,0,0,0,18.6,300.446Z",
    transform: "translate(0 -298.667)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.e5defcd6.svg";
export { ForwardRef as ReactComponent };